import type { FC } from "react";
import { useEffect, useState } from "react";
import styles from "@/layout/agentChat/agentChatDrawer.module.scss";
import { SparkleIcon } from "@phosphor-icons/react/Sparkle";
import { useTranslation } from "react-i18next";

type AgentEmptyStateProps = {
  onSelectPrompt: (text: string) => void;
}

const NUM_PROMPTS_TO_SHOW = 3;

const AgentEmptyState: FC<AgentEmptyStateProps> = ({ onSelectPrompt }) => {
  const { t, i18n } = useTranslation("translation", { keyPrefix: "agentChat" });

  const getRandomPrompts = () => {
    const all = t("examplePrompts", { returnObjects: true }) as string[];
    if (!Array.isArray(all)) return [];
    const shuffled = [...all].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, Math.min(NUM_PROMPTS_TO_SHOW, all.length));
  };

  const [prompts, setPrompts] = useState<string[]>(getRandomPrompts);

  useEffect(() => {
    const handleLanguageChange = () => setPrompts(getRandomPrompts());
    i18n.on("languageChanged", handleLanguageChange);
    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [t]);

  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyStateIcon}>
        <div className={styles.agentIcon}>
          <SparkleIcon size={20} />
        </div>
      </div>
      <p className={styles.emptyStateGreeting}>{t("greeting")}</p>
      <p className={styles.emptyStateSubtitle}>{t("greetingSubtitle")}</p>
      <div className={styles.examplePrompts}>
        {prompts.map((prompt, i) => (
          <button
            key={i}
            className={styles.examplePrompt}
            onClick={() => onSelectPrompt(prompt)}
          >
            {prompt}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AgentEmptyState;
